@if (form$ | async; as form) {
  <fieldset class="rounded-md border border-solid border-gray-300 p-4">
    <legend class="inline-block px-2 text-sm font-medium">SDS</legend>
    <form class="flex flex-col gap-3" [formGroup]="form">
      <div class="flex items-start gap-2">
        <mat-form-field class="w-full" subscriptSizing="dynamic">
          <mat-label>Treatment Circumstance</mat-label>
          <mat-select formControlName="treatmentReason">
            @for (reason of treatmentReasons; track reason) {
              <mat-option [value]="reason">
                {{ treatmentReasonsMap[reason].label }}
              </mat-option>
            }
          </mat-select>
          @if (reasonHint$ | async; as hint) {
            <mat-hint class="text-primary-500">{{ hint }}</mat-hint>
          }
        </mat-form-field>
        <mat-form-field class="w-full" subscriptSizing="dynamic">
          <mat-label>Name of school or oral health practitioner</mat-label>
          <input matInput formControlName="schoolOrOralHealthCentre" />
        </mat-form-field>
      </div>
      <div class="flex gap-2">
        <mat-form-field class="w-full" subscriptSizing="dynamic">
          <mat-label>Town/city of school or oral health practitioner</mat-label>
          <input matInput formControlName="schoolTown" />
        </mat-form-field>
        <mat-form-field class="w-full" subscriptSizing="dynamic">
          <mat-label>Name of usual oral health practitioner</mat-label>
          <input matInput formControlName="usualOralHealthPractitioner" />
        </mat-form-field>
      </div>
      <div class="flex gap-2">
        <mat-form-field class="w-full" subscriptSizing="dynamic">
          <mat-label>Town/city of usual oral health practitioner</mat-label>
          <input matInput formControlName="practitionerTown" />
        </mat-form-field>
        <mat-form-field class="w-full" subscriptSizing="dynamic">
          <mat-label>Community Oral Health Service referral number</mat-label>
          <input matInput formControlName="cohsReferralNumber" />
        </mat-form-field>
      </div>
    </form>
  </fieldset>
}
